import React from 'react';
import { PlayArrow } from '@material-ui/icons';

import SimpleVideoPlayer from '../blogComponents/SimpleVideoPlayer';
import './FeaturedSection.css';
import '../../css/player.css';
import SfwImage from '../AgeVerificationComponents/SfwImage';
import { UserContext } from '../../context';
import MembersOnlyImage from '../../assets/Featured/members-only.png';


function FeaturedMediaComponent(props) {
  const { featuredItem, loggedInUser, type, useDefaultContainer } = props;
  const user = React.useContext(UserContext);
  const clip = {
    clipUrl: featuredItem?.clipUrl,
    imageUrl: featuredItem?.imageUrl,
  };
  const imageSrc =
    featuredItem?.programSegments?.[0]?.clip?.thumbnailImageUrl ||
    featuredItem.thumbnailImageUrl ||
    featuredItem.image ||
    featuredItem.imageUrl ||
    featuredItem.clip.thumbnailImageUrl ||
    featuredItem.clip.imageUrl ||
    featuredItem?.asset;
  // Real (NSFW) video is only shown once the user has both logged in and
  // affirmed/verified their age. Everyone else (guests and unverified members)
  // gets the SFW image treatment.
  const ageAffirmed = sessionStorage.getItem('adult_content_ack') === 'true';
  const wasAgeVerified =
    !user?.sfw && user?.authenticated === true && ageAffirmed;
  if (
    featuredItem?.clipUrl?.endsWith('null') ||
    !featuredItem?.clipUrl ||
    user?.sfw ||
    !wasAgeVerified
  ) {
    return (
      <div className="content-item-thumbnail">
        {type === 'clipstore' && <PlayArrow />}
        <SfwImage
          alt="Xlthumb placeholder"
          loading="lazy"
          nsfwImage={imageSrc}
          overlayedImage={MembersOnlyImage}
          sfwImage={featuredItem?.sfwAssetImage}
          style={{ opacity: 1, width: '100%' }}
        />
      </div>
    );
  }

  return (
    <SimpleVideoPlayer
      autoPlayVideo={false}
      clip={clip}
      fanZoneFreeVideo={loggedInUser !== undefined}
      isFeaturedClip={true}
      useDefaultContainer={useDefaultContainer}
      user={loggedInUser}
      videoClass={true}
    />
  );
}

export default FeaturedMediaComponent;

FeaturedMediaComponent.defaultProps = { useDefaultContainer: true };
